import { beforeCancelTransactionItem } from '@/apis/system';

export const beforeCancelItem = (code) => {
    return beforeCancelTransactionItem(code).then(res => {
        return { msg: res.data.msg, success: true };
    }).catch(e => {
        return { msg: e.data, success: false };
    });
};
// export default removeItem;
